export const loadScript = (module: string, src: string): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    const scriptId = `script-${module}`;
    if (document.getElementById(scriptId)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.id = scriptId;
    script.type = 'module';
    document.body.appendChild(script);
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Script failed to load'));
  });
};
